module.exports = __webpack_public_path__ + "img/oumph.fdd479f7.webp";